function QuizQuestionTracker({ quiz_type, questions, answers, currentIndex, onJump, checkAnswers }) {


    return (
        <div className="flex flex-wrap gap-2 mb-6">
            {questions.map((q, idx) => {
                const answer = answers[q.id];
                let isAnswered = false;
                let isIncorrect = false;

                if (q.question_type === 'objective') {
                    isAnswered = !!answer?.selected_option;
                    isIncorrect = isAnswered && answer.selected_option !== q.options.find(opt => opt.is_correct)?.id;

                } else if (q.question_type == 'multiple_select') {
                    isAnswered = answer?.selected_options?.length > 0
                    isIncorrect = isAnswered && q.options.some(opt => 
                        opt.is_correct !== answer.selected_options.includes(opt.id)
                    );
                } else if (q.question_type === 'theory') {
                    isAnswered = !!answer?.theory_answer?.trim();
                    isIncorrect = isAnswered && !q.theory_answer?.trim().toLowerCase().includes(answer.theory_answer.trim().toLowerCase());

                } else if (q.question_type === 'matching') {
                    isAnswered = Array.isArray(answer?.matching_answers) && answer.matching_answers.length === q.matching_pair.length;
                    isIncorrect = isAnswered && !q.matching_pair.every(pair =>
                        answer.matching_answers.some(ans => ans.pair_id === pair.id && ans.answer_id === pair.answer_id)
                    );
                }

                isIncorrect =  checkAnswers[q.id] && isIncorrect;

                const isCurrent = idx === currentIndex;
                let buttonClass = 'w-8 h-8 rounded-full border text-xs font-bold hover:ring-2 hover:ring-primary transition ';

                if (isCurrent) {
                    buttonClass += 'bg-primary text-white border-primary';
                } else if (isIncorrect && quiz_type == 'learning') {
                    buttonClass += 'bg-red-100 border-red-400 text-red-800';
                } else if (isAnswered) {
                    buttonClass += 'bg-green-100 border-green-400 text-green-800';
                } else {
                    buttonClass += 'bg-gray-100 border-gray-300 text-gray-500';
                }


                return (
                    <button
                        key={q.id}
                        className={buttonClass}
                        onClick={() => onJump(idx)}
                        type="button"
                        aria-label={`Go to question ${idx + 1}`}
                    >
                        {idx + 1}
                    </button>
                );
            })}
        </div>
    );
}

export default QuizQuestionTracker;
